import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppLayout from '@/layouts/AppLayout.vue'
import { SideNotificationsVue } from '@/notifications'
import DevPanel from '@/components/DevPanel.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppLayout),
    _createVNode(_unref(SideNotificationsVue)),
    _createVNode(DevPanel)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})